var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxAlarmExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.9981C16.879 21.9981 21 17.8771 21 12.9981C21 8.11906 16.879 3.99806 12 3.99806C7.12097 3.99806 2.99997 8.11906 2.99997 12.9981C2.99997 17.8771 7.12097 21.9981 12 21.9981ZM12 5.99806C15.794 5.99806 19 9.20406 19 12.9981C19 16.7921 15.794 19.9981 12 19.9981C8.20597 19.9981 4.99997 16.7921 4.99997 12.9981C4.99997 9.20406 8.20597 5.99806 12 5.99806ZM17.284 3.70506L18.696 2.28906L21.706 5.28906L20.293 6.70606L17.284 3.70506ZM5.28197 2.29206L6.69997 3.70406L3.70997 6.70406L2.29297 5.29106L5.28197 2.29206Z",
    fill: "#767676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9H13V14H11V9ZM11 15H13V17H11V15Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxAlarmExclamation);
export default __webpack_public_path__ + "static/media/bx-alarm-exclamation.0dc64c153bdfe07cdd5825d796c55333.svg";
export { ForwardRef as ReactComponent };